<template>
    <v-card>
        <v-card-title class="text--white80 pa-0 pt-2 contact-page-title">
            <v-btn icon class="text--white80 px-6" @click="goBack">
                <v-icon large left class="text--white80">mdi-arrow-u-left-top</v-icon>
            </v-btn>
            <span class="title font-weight-light">Add a new sailor friend</span>
        </v-card-title>
        <v-form ref="contactForm"
                class="backgroundWhite35 pa-3 contact-form-compact"
                v-model="valid"
                lazy-validation>
            <v-text-field v-model="name"
                          class="text-input-white"
                          dense
                          :counter="30"
                          :rules="nameRules"
                          label="Name"
                          color="white"
                          required></v-text-field>
            <v-text-field v-model="email"
                          :rules="emailRules"
                          class="text-input-white"
                          dense
                          label="E-mail"
                          color="white"
                          required></v-text-field>
            <v-container fluid class="contact-phone-container">
                <v-row class="contact-phone-row">
                    <v-col cols="12" class="contact-phone-column">
                        <div class="d-flex flex-column">
                            <div>
                                <div class="text-matching-input-label">
                                    Phone number
                                </div>
                                <vue-tel-input class="tel-input--blue" v-model="vueTel.phone" v-bind="vueTel.props" @validate="phoneObject"></vue-tel-input>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <v-row class="justify-center contact-notification-section">
                <span class="white--text font-weight-bold">Notification Options</span>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-email">
                            E-mail Notifications
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row justify="space-between" class="align-start notification-checkbox-grid">
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption notification-group-caption" style="font-style: italic;">The following notifications will be sent in 'Armed' state.</span>
                                        <v-checkbox v-model="gatewayPowerlossActive" label="GTW Power Loss" prepend-icon="mdi-power-plug-off" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="shorePowerActive" label="Shore Power" prepend-icon="mdi-meter-electric" class="py-0 my-0" />
                                        <v-checkbox v-model="smartplugActive" label="Smart Plug" prepend-icon="mdi-power-plug" class="py-0 my-0" />
                                        <v-checkbox v-model="mainDoorActive" label="Main Door" prepend-icon="mdi-door" class="py-0 my-0" />
                                        <v-checkbox v-model="hatchActive" label="Hatch Door" prepend-icon="mdi-door" class="py-0 my-0" />
                                        <v-checkbox v-model="geofenceActive" label="Geofence" prepend-icon="mdi-map-marker-radius" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                                <v-divider vertical inset style="margin-top: 15px; margin-bottom: 30px;"></v-divider>
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption notification-group-caption" style="font-style: italic;">The following notifications will be sent in any state.</span>
                                        <v-checkbox v-model="gatewayTamperedActive" label="GTW Tampered" prepend-icon="mdi-domino-mask" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="detectorsActive" label="Detectors" prepend-icon="mdi-security" class="py-0 my-0" />
                                        <v-checkbox v-model="voltageLowActive" label="Low Voltage" prepend-icon="mdi-sail-boat" class="py-0 my-0" />
                                        <v-checkbox v-model="lowBatteryActive" label="Low Battery" prepend-icon="mdi-access-point" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-message-text">
                            SMS Notifications
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row justify="space-between" class="align-start notification-checkbox-grid">
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption notification-group-caption" style="font-style: italic;">The following notifications will be sent in 'Armed' state.</span>
                                        <v-checkbox v-model="gatewayPowerlossSMSActive" label="GTW Power Loss" prepend-icon="mdi-power-plug-off" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="shorePowerSMSActive" label="Shore Power" prepend-icon="mdi-meter-electric" class="py-0 my-0" />
                                        <v-checkbox v-model="smartplugSMSActive" label="Smart Plug" prepend-icon="mdi-power-plug" class="py-0 my-0" />
                                        <v-checkbox v-model="mainDoorSMSActive" label="Main Door" prepend-icon="mdi-door" class="py-0 my-0" />
                                        <v-checkbox v-model="hatchSMSActive" label="Hatch Door" prepend-icon="mdi-calendar-minus" class="py-0 my-0" />
                                        <v-checkbox v-model="geofenceSMSActive" label="Geofence" prepend-icon="mdi-map-marker-radius" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                                <v-divider vertical inset style="margin-top: 15px; margin-bottom: 30px;"></v-divider>
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption notification-group-caption" style="font-style: italic;">The following notifications will be sent in any state.</span>
                                        <v-checkbox v-model="gatewayTamperedSMSActive" label="GTW Tampered" prepend-icon="mdi-domino-mask" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="detectorsSMSActive" label="Detectors" prepend-icon="mdi-security" class="py-0 my-0" />
                                        <v-checkbox v-model="voltageLowSMSActive" label="Low Voltage" prepend-icon="mdi-sail-boat" class="py-0 my-0" />
                                        <v-checkbox v-model="lowBatterySMSActive" label="Low Battery" prepend-icon="mdi-access-point" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn :disabled="!valid || !isValid"
                           color="primary"
                           @click="initSave">
                        <v-icon left>
                            mdi-check
                        </v-icon>
                        SAVE
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <ConfirmDialog v-model="showSuccess"
                       :options="{ noconfirm: true }"
                       title="Success"
                       message="Sailor friend addded successfully."
                       @OnOk="successOk"></ConfirmDialog>
        <ConfirmDialog v-model="showStatus"
                       :options="{ noconfirm: true }"
                       :title="statusTitle"
                       :message="statusMessage" />
        <ConfirmDialog v-model="showLeaveConfirm"
                       :options="{ persistent: true }"
                       title="Unsaved Changes"
                       message="You have unsaved changes. Do you really want to leave without saving?"
                       @OnOk="leaveWithoutSaving" />
    </v-card>
</template>
<script lang="ts">
    import { computed, defineComponent, ref, onMounted, getCurrentInstance } from "vue";
    import useContact from "@/store/useContact";
    import ContactViewModel from "@/models/ContactViewModel";
    import { VueTelInput } from "vue-tel-input";
    import { profile as profilestore } from "@/store";

    export default defineComponent({
        components: {
            VueTelInput,
            ConfirmDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue")
        },
        setup() {
            const root = getCurrentInstance()?.proxy as any;
            const captainEmail = computed(() => {
                const email = profilestore.profile && profilestore.profile.userId;
                return email ? email.toLowerCase() : "";
            });
            const { add, nameRules, emailRules } = useContact({ captainEmail: captainEmail.value });

            const contactForm = ref<HTMLFormElement>();
            const valid = ref<boolean>(true);
            const showSuccess = ref<boolean>(false);
            const showStatus = ref<boolean>(false);
            const showLeaveConfirm = ref<boolean>(false);
            const statusTitle = ref<string>("Unable to add contact");
            const statusMessage = ref<string>("Please try again.");
            const name = ref<string>("");
            const email = ref<string>("");
            const vueTel = {
                phone: "",
                props: {
                    autoFormat: true,
                    autoDefaultCountry: true,
                    dropdownOptions: {
                        showDialCodeInList: true,
                        showDialCodeInSelection: false,
                        showFlags: true,
                        showSearchBox: true,
                        width: '300px',
                    },
                    ignoredCountries: ["KP", "RU"],
                    inputOptions: {
                        autocomplete: 'on',
                        showDialCode: true,
                        placeholder: 'Enterphone number',
                        required: true,
                    },
                    mode: "international",
                    preferredCountries: ["DK", "NO", "SE"],
                    validCharactersOnly: true,
                }
            };
            const detectorsActive = ref<boolean>(false);
            const shorePowerActive = ref<boolean>(false);
            const smartplugActive = ref<boolean>(false);
            const mainDoorActive = ref<boolean>(false);
            const hatchActive = ref<boolean>(false);
            const voltageLowActive = ref<boolean>(false);
            const geofenceActive = ref<boolean>(false);
            const lowBatteryActive = ref<boolean>(false);
            const gatewayTamperedActive = ref<boolean>(false);
            const gatewayPowerlossActive = ref<boolean>(false);

            const detectorsSMSActive = ref<boolean>(false);
            const shorePowerSMSActive = ref<boolean>(false);
            const smartplugSMSActive = ref<boolean>(false);
            const mainDoorSMSActive = ref<boolean>(false);
            const hatchSMSActive = ref<boolean>(false);
            const voltageLowSMSActive = ref<boolean>(false);
            const geofenceSMSActive = ref<boolean>(false);
            const lowBatterySMSActive = ref<boolean>(false);
            const gatewayTamperedSMSActive = ref<boolean>(false);
            const gatewayPowerlossSMSActive = ref<boolean>(false);

            const isValid = ref(false);

            const normalizeContactState = (state) => ({
                name: (state.name || "").trim(),
                email: (state.email || "").trim(),
                phoneNumber: (state.phoneNumber || "").trim(),
                detectorsActive: !!state.detectorsActive,
                shorePowerActive: !!state.shorePowerActive,
                smartplugActive: !!state.smartplugActive,
                mainDoorActive: !!state.mainDoorActive,
                hatchActive: !!state.hatchActive,
                voltageLowActive: !!state.voltageLowActive,
                geofenceActive: !!state.geofenceActive,
                lowBatteryActive: !!state.lowBatteryActive,
                gatewayTamperedActive: !!state.gatewayTamperedActive,
                gatewayPowerlossActive: !!state.gatewayPowerlossActive,
                detectorsSMSActive: !!state.detectorsSMSActive,
                shorePowerSMSActive: !!state.shorePowerSMSActive,
                smartplugSMSActive: !!state.smartplugSMSActive,
                mainDoorSMSActive: !!state.mainDoorSMSActive,
                hatchSMSActive: !!state.hatchSMSActive,
                voltageLowSMSActive: !!state.voltageLowSMSActive,
                geofenceSMSActive: !!state.geofenceSMSActive,
                lowBatterySMSActive: !!state.lowBatterySMSActive,
                gatewayTamperedSMSActive: !!state.gatewayTamperedSMSActive,
                gatewayPowerlossSMSActive: !!state.gatewayPowerlossSMSActive,
            });

            const buildContactState = () => ({
                name: name.value,
                email: email.value,
                phoneNumber: vueTel.phone,
                detectorsActive: detectorsActive.value,
                shorePowerActive: shorePowerActive.value,
                smartplugActive: smartplugActive.value,
                mainDoorActive: mainDoorActive.value,
                hatchActive: hatchActive.value,
                voltageLowActive: voltageLowActive.value,
                geofenceActive: geofenceActive.value,
                lowBatteryActive: lowBatteryActive.value,
                gatewayTamperedActive: gatewayTamperedActive.value,
                gatewayPowerlossActive: gatewayPowerlossActive.value,
                detectorsSMSActive: detectorsSMSActive.value,
                shorePowerSMSActive: shorePowerSMSActive.value,
                smartplugSMSActive: smartplugSMSActive.value,
                mainDoorSMSActive: mainDoorSMSActive.value,
                hatchSMSActive: hatchSMSActive.value,
                voltageLowSMSActive: voltageLowSMSActive.value,
                geofenceSMSActive: geofenceSMSActive.value,
                lowBatterySMSActive: lowBatterySMSActive.value,
                gatewayTamperedSMSActive: gatewayTamperedSMSActive.value,
                gatewayPowerlossSMSActive: gatewayPowerlossSMSActive.value,
            });

            const originalState = ref(normalizeContactState(buildContactState()));
            const pendingRoute = ref<null | ((allow?: boolean) => void)>(null);
            const allowLeave = ref(false);

            const setPendingRoute = (next) => {
                pendingRoute.value = next;
            };

            const isEmptyPhone = (phone: string) => {
                const trimmed = (phone || "").trim();
                return trimmed === "" || /^\+\d{1,3}$/.test(trimmed) || trimmed === "+";
            };

            const isEmptyState = (state) =>
                Object.entries(state).every(([key, value]) => {
                    if (key === "phoneNumber") {
                        return isEmptyPhone(String(value));
                    }
                    return value === "" || value === false;
                });

            const hasUnsavedChanges = () => {
                const currentState = normalizeContactState(buildContactState());
                if (isEmptyState(currentState)) {
                    return false;
                }
                const changed = !root.$_.isEqual(currentState, originalState.value);
                return changed;
            };

            onMounted(() => {
                originalState.value = normalizeContactState(buildContactState());
            });

            const phoneObject = function (object) {
                if (object.valid === true) {
                    isValid.value = true;
                } else {
                    isValid.value = false;
                }
            };

            const handleStatus = (status: number) => {
                if (status === 200) {
                    showSuccess.value = true;
                    return;
                }

                if (status === 403) {
                    statusTitle.value = "Not allowed";
                    statusMessage.value = "Only the captain can add sailor friends for this device.";
                } else if (status === 409) {
                    statusTitle.value = "Duplicate email";
                    statusMessage.value = "This email already exists for this device or belongs to a captain.";
                } else if (status === 400) {
                    statusTitle.value = "Invalid email";
                    statusMessage.value = "Please enter a valid email address.";
                } else {
                    statusTitle.value = "Unable to add contact";
                    statusMessage.value = "Please try again.";
                }

                showStatus.value = true;
            };

            const initSave = async () => {
                if (contactForm.value) {
                    const isFormValid = contactForm.value.validate();
                    if (isFormValid && isValid.value) {
                        const newContact = new ContactViewModel();
                        newContact.name = name.value;
                        newContact.email = email.value;
                        newContact.active = true;
                        newContact.phoneNumber = vueTel.phone;
                        newContact.detectorsEmailActive = detectorsActive.value;
                        newContact.shorePowerEmailActive = shorePowerActive.value;
                        newContact.smartplugEmailActive = smartplugActive.value;
                        newContact.mainDoorEmailActive = mainDoorActive.value;
                        newContact.hatchEmailActive = hatchActive.value;
                        newContact.voltageLowEmailActive = voltageLowActive.value;
                        newContact.geofenceEmailActive = geofenceActive.value;
                        newContact.lowBatterySensorEmailActive = lowBatteryActive.value;
                        newContact.gatewayTamperedEmailActive = gatewayTamperedActive.value;
                        newContact.gatewayPowerlossEmailActive = gatewayPowerlossActive.value;
                        newContact.detectorsSMSActive = detectorsSMSActive.value;
                        newContact.shorePowerSMSActive = shorePowerSMSActive.value;
                        newContact.smartPlugSMSActive = smartplugSMSActive.value;
                        newContact.mainDoorSMSActive = mainDoorSMSActive.value;
                        newContact.hatchSMSActive = hatchSMSActive.value;
                        newContact.voltageLowSMSActive = voltageLowSMSActive.value;
                        newContact.geofenceSMSActive = geofenceSMSActive.value;
                        newContact.lowBatterySensorSMSActive = lowBatterySMSActive.value;
                        newContact.gatewayTamperedSMSActive = gatewayTamperedSMSActive.value;
                        newContact.gatewayPowerlossSMSActive = gatewayPowerlossSMSActive.value;
                        newContact.gsmConnectionLostEmailActive = false; // never allow contacts to have this active
                        newContact.gsmConnectionLostSMSActive = false; // never allow contacts to have this active
                        const status = await add(newContact);
                        handleStatus(status);
                    } else {
                        valid.value = isFormValid;
                    }
                }
            };

            const successOk = () => {
                window.history.back();
            };

            const goBack = () => {
                if (hasUnsavedChanges()) {
                    pendingRoute.value = null;
                    showLeaveConfirm.value = true;
                } else {
                    window.history.back();
                }
            };

            const leaveWithoutSaving = () => {
                allowLeave.value = true;
                if (pendingRoute.value) {
                    const next = pendingRoute.value;
                    pendingRoute.value = null;
                    next();
                } else {
                    window.history.back();
                }
            };

            return {
                contactForm,
                valid,
                name,
                email,
                vueTel,
                phoneObject,
                isValid,
                detectorsActive,
                shorePowerActive,
                smartplugActive,
                mainDoorActive,
                hatchActive,
                voltageLowActive,
                geofenceActive,
                lowBatteryActive,
                gatewayTamperedActive,
                gatewayPowerlossActive,
                detectorsSMSActive,
                shorePowerSMSActive,
                smartplugSMSActive,
                mainDoorSMSActive,
                hatchSMSActive,
                voltageLowSMSActive,
                geofenceSMSActive,
                lowBatterySMSActive,
                gatewayTamperedSMSActive,
                gatewayPowerlossSMSActive,
                nameRules,
                emailRules,
                showSuccess,
                showStatus,
                statusTitle,
                statusMessage,
                showLeaveConfirm,
                successOk,
                hasUnsavedChanges,
                setPendingRoute,
                allowLeave,
                goBack,
                leaveWithoutSaving,
                initSave
            };
        },
        beforeRouteLeave(to, from, next) {
            if (this.allowLeave) {
                this.allowLeave = false;
                next();
                return;
            }
            if (this.hasUnsavedChanges && this.hasUnsavedChanges()) {
                this.setPendingRoute(next);
                this.showLeaveConfirm = true;
            } else {
                next();
            }
        },
    });
</script>
<style scoped lang="scss">
    .contact-page-title {
        min-height: 48px;
    }

    .contact-form-compact {
        padding-top: 8px !important;
    }

    .contact-phone-container {
        padding: 0;
    }

    .contact-phone-row {
        margin: 0;
    }

    .contact-phone-column {
        padding: 4px 0 8px;
    }

    .contact-notification-section {
        margin: 0;
    }

    .contact-notification-section > span {
        padding: 8px 0;
    }

    .contact-form-compact ::v-deep .v-text-field {
        margin-top: 4px;
        padding-top: 4px;
    }

    .contact-form-compact ::v-deep .v-expansion-panel-header {
        min-height: 48px;
        padding: 0 12px;
        font-size: var(--app-font-body);
    }

    .contact-form-compact ::v-deep .v-expansion-panel-content__wrap {
        padding: 0 8px 8px;
    }

    .contact-form-compact ::v-deep .v-input--checkbox {
        margin-top: 0;
        padding-top: 0;
    }

    .contact-form-compact ::v-deep .v-input--checkbox .v-input__slot {
        min-height: 32px;
        margin-bottom: 0;
        align-items: center !important;
    }

    .contact-form-compact ::v-deep .v-input--checkbox .v-label {
        font-size: var(--app-font-compact);
        line-height: 1rem;
    }

    .contact-form-compact ::v-deep .v-input--checkbox .v-input__prepend-outer {
        margin-right: 4px;
    }

    .contact-form-compact ::v-deep .v-input--checkbox .v-input--selection-controls__input {
        margin-right: 4px;
    }

    .contact-form-compact ::v-deep .v-flex > .col {
        padding: 8px;
    }

    @media (max-width: 600px) {
        .contact-form-compact ::v-deep .v-input--checkbox .v-input__prepend-outer {
            display: none;
        }
    }

    .v-card ::v-deep .text-input-white .v-text-field__slot input {
        color: #fff !important;
    }

    ::v-deep .v-input .v-input__control .v-input__slot {
        align-items: start;
    }

    .text-matching-input-label {
        font-size: var(--app-font-caption) !important;
        color: #0009 !important;
        font-size: var(--app-font-small) !important;
    }
</style>